/**
 * 21/01/2026
 * FS Natulim:
 * Redirige al subdirectorio /ca cuando el navegador del visitante está
 * configurado en catalán pero aún no visita la ruta traducida.
 * El valor se guarda en sessionStorage para que solo dure mientras dura la sesión.
 */
(function () {
  const STORAGE_KEY = 'natulim_ca_lang_redirect_done';

  try {
    // Evita redirecciones repetidas dentro de la misma sesión.
    if (sessionStorage.getItem(STORAGE_KEY)) {
      return;
    }

    const path = window.location.pathname;

    // Si ya estamos en la versión catalana, no hacemos nada.
    if (path.startsWith('/ca')) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      return;
    }

    // Detectamos el idioma preferido del navegador.
    const lang =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      '';

    const isCatalan = lang.toLowerCase().startsWith('ca');

    if (isCatalan) {
      // Guardamos el valor para esta sesión antes de redirigir.
      sessionStorage.setItem(STORAGE_KEY, 'true');
      window.location.href = '/ca' + path + window.location.search;
      return;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.has('fbclid')) {
      return;
    }
  } catch (error) {
    if (window.console && console.error) {
      console.error('ca-lang-redirect', error);
    }
  }
})();
